import { useEffect, useState } from 'react'

export function useScrollActivity(delay = 150) {
  const [isScrolling, setIsScrolling] = useState(false)

  useEffect(() => {
    let timeoutId: NodeJS.Timeout

    const onScroll = () => {
      if (!isScrolling) {
        setIsScrolling(true)
      }

      clearTimeout(timeoutId)
      timeoutId = setTimeout(() => {
        setIsScrolling(false)
      }, delay)
    }

    window.addEventListener('scroll', onScroll)

    return () => {
      window.removeEventListener('scroll', onScroll)
      clearTimeout(timeoutId)
    }
  }, [delay, isScrolling])

  return isScrolling
}
